import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

const Register = ({ onLogin }) => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [referral] = useState(searchParams.get('ref') || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) return setError('Passwords do not match');
    if (password.length < 6) return setError('Password must be at least 6 characters');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, referral })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      if (onLogin) onLogin(data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vauth-page">
      <div className="vauth-left">
        <div className="vauth-left-glow"></div>
        <div className="vauth-left-glow2"></div>
        <div className="vauth-left-content">
          <img src="/logo.png" alt="Outsourced" className="vauth-logo-img" />
          <h1 className="vauth-brand-title">Outsourced</h1>
          <p className="vauth-brand-tagline">Premium Discord Server Boosts</p>
          <div className="vauth-features">
            <div className="vauth-feature">
              <div className="vauth-feature-icon">⚡</div>
              <div>
                <div className="vauth-feature-title">Instant Delivery</div>
                <div className="vauth-feature-desc">Boosts delivered automatically within seconds</div>
              </div>
            </div>
            <div className="vauth-feature">
              <div className="vauth-feature-icon">🛡️</div>
              <div>
                <div className="vauth-feature-title">Secure & Reliable</div>
                <div className="vauth-feature-desc">Crypto payments with full order tracking</div>
              </div>
            </div>
            <div className="vauth-feature">
              <div className="vauth-feature-icon">💰</div>
              <div>
                <div className="vauth-feature-title">Best Prices</div>
                <div className="vauth-feature-desc">Cheapest boosts on the market, guaranteed</div>
              </div>
            </div>
          </div>
        </div>
        <div className="vauth-left-footer">© 2025 Outsourced</div>
      </div>

      <div className="vauth-right">
        <div className="vauth-form-wrap">
          <div className="vauth-form-header">
            <h2 className="vauth-form-title">Create account</h2>
            <p className="vauth-form-sub">Get started with your own dashboard</p>
          </div>

          {error && <div className="vauth-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="vauth-field">
              <label>Email Address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@email.com" required />
            </div>
            <div className="vauth-field">
              <label>Password</label>
              <div className="vauth-pw-wrap">
                <input type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
                <button type="button" className="vauth-pw-toggle" onClick={() => setShowPw(!showPw)}>
                  {showPw ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  )}
                </button>
              </div>
            </div>
            <div className="vauth-field">
              <label>Confirm Password</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="••••••••" required />
            </div>
            {referral && (
              <div className="vauth-field">
                <label>Referral Code</label>
                <input type="text" value={referral} readOnly style={{opacity:0.6}} />
              </div>
            )}
            <button type="submit" className="vauth-submit" disabled={loading}>
              {loading ? <span className="vauth-spinner"></span> : 'Create Account'}
            </button>
          </form>

          <div className="vauth-divider"><span>or</span></div>

          <p className="vauth-switch">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
